import React from 'react'

import Button from '../Button/Button'

import {
  QuestionBankCard,
  QuestionBankCardInner,
  QuestionBankTitle,
  QuestionBankSubTitle,
  QuestionBankCardDetails,
  QuestionBankCardDetailsLeft,
  QuestionBankCardDetailsLeftBackground,
  QuestionBankCardDetailsRight,
  QuestionBankCounterContainer,
  QuestionBankCounter,
  QuestionBankCounterTitle,
  StartQuestionContainer,
  QuestionBankProgressContainer,
} from './QuestionBankCard-styled'

export default ({ id, title, progressCounter, imgSrc, available, startWorkout, ProgressBar }) => {
  const bgImgStyle = imgSrc ? { backgroundImage: `url(${imgSrc})` } : {}
  return (
    <QuestionBankCard style={bgImgStyle}>
      <QuestionBankCardInner imgSrc={imgSrc}>
        <QuestionBankCardDetails>
          <QuestionBankCardDetailsLeftBackground />
          <QuestionBankCardDetailsLeft>
            <QuestionBankTitle>{title}</QuestionBankTitle>
            <QuestionBankSubTitle>Workout</QuestionBankSubTitle>
            {progressCounter && (
              <QuestionBankCounterContainer>
                <QuestionBankCounter>{progressCounter}</QuestionBankCounter>
                <QuestionBankCounterTitle>Consecutive Days</QuestionBankCounterTitle>
              </QuestionBankCounterContainer>
            )}
          </QuestionBankCardDetailsLeft>
          <QuestionBankCardDetailsRight>
            {available && (
              <StartQuestionContainer>
                <Button title="Start" onClick={startWorkout} animateOnClick />
              </StartQuestionContainer>
            )}
          </QuestionBankCardDetailsRight>
        </QuestionBankCardDetails>
        <QuestionBankProgressContainer>
          <ProgressBar questionBankId={id} />
        </QuestionBankProgressContainer>
      </QuestionBankCardInner>
    </QuestionBankCard>
  )
}



// WEBPACK FOOTER //
// ./src/component/_presentational/QuestionBankCard/QuestionBankCard.jsx